import React, { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Calendar } from "../ui/calendar";
import { CalendarIcon, X } from "lucide-react";

export default function DatePicker({ value, onChange, placeholder = "Pick a date", testId }) {
  const [open, setOpen] = useState(false);
  const parsed = value ? parse(value, "yyyy-MM-dd", new Date()) : null;
  const display = parsed && isValid(parsed) ? format(parsed, "MMM d, yyyy") : "";

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="w-full flex items-center justify-between bg-white border border-zinc-200 hover:border-zinc-950 rounded-md shadow-sm h-9 text-sm px-3 text-left"
        >
          <span className={display ? "text-zinc-950" : "text-zinc-400"}>{display || placeholder}</span>
          {display ? (
            <X
              className="h-3.5 w-3.5 text-zinc-400 hover:text-zinc-950"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onChange("");
              }}
            />
          ) : (
            <CalendarIcon className="h-3.5 w-3.5 text-zinc-400" />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white border border-zinc-200" align="start">
        <Calendar
          mode="single"
          selected={parsed || undefined}
          onSelect={(date) => {
            if (!date) return;
            onChange(format(date, "yyyy-MM-dd"));
            setOpen(false);
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
